export const ru = {
    archived: 'Архивная',
    autobudget: 'Недельный бюджет',
    'autobudget-avg-click': 'Средняя цена клика',
    'autobudget-avg-cpa': 'Средняя цена конверсии',
    'autobudget-avg-cpa-per-camp':
        'Оптимизация количества конверсий на всю кампанию',
    'autobudget-avg-cpa-per-filter':
        'Оптимизация количества конверсий на фильтр',
    'autobudget-avg-cpc-per-camp':
        'Оптимизация количества кликов на всю кампанию',
    'autobudget-avg-cpc-per-filter': 'Оптимизация количества кликов на фильтр',
    'autobudget-avg-cpi': 'Средняя цена установки приложения',
    'autobudget-max-impressions': 'Максимум показов по минимальной цене',
    'autobudget-max-reach': 'Снижение цены повторных показов',
    'autobudget-media': 'Медиа',
    'autobudget-roi': 'Средняя рентабельность инвестиций',
    'autobudget-week-bundle': 'Недельный пакет кликов',
    avgClickCost: 'CPC',
    avgGoalCost: 'CPA',
    'bid-modifiers': 'Корректировки ставок',
    both: 'На поиске и в сетях',
    'bounce-rate': 'Отказы',
    brandlift: 'Исследования',
    broadmatch: 'Дополнительные релевантные фразы',
    'budget-limit-with-currency': 'Бюджет, {currency}',
    budgetLimit: 'Бюджет',
    'campaign-type': 'Тип кампании',
    clicks: 'Клики',
    context: 'В сетях',
    'converison-rate': 'Коэффициент конверсии',
    cost: 'Расход',
    'cpm-default': 'Максимально возможный объем показов',
    ctr: 'CTR',
    default: 'Ручное управление',
    draft: 'Черновик',
    'finish-date': 'Дата окончания',
    goals: 'Конверсии',
    id: 'Id',
    metrics: 'Статистика',
    metrika: 'Счетчик Метрики',
    'moderation-denied': 'Отклонено модерацией',
    'moderation-pending': 'На модерации',
    'money-finished': 'Закончились деньги',
    name: 'Название',
    'name-suggest': 'Название содержит',
    'no-premium': 'Показ под результатами',
    number: 'Номер',
    platform: 'Места показов',
    profitability: 'ROI',
    revenue: 'Доход',
    search: 'На поиске',
    settings: 'Настройки',
    shows: 'Показы',
    'site-monitoring': 'Мониторинг сайта',
    'start-date': 'Дата начала',
    started: 'Запущена',
    status: 'Статус',
    stopped: 'Остановленная',
    strategy: 'Стратегия',
    sum: 'Осталось',
    'sum-with-currency': 'Осталось, {currency}',
    'temporarily-paused': 'Временно остановлена',
    text: 'Текстовая',
    type: 'Тип'
};
